<template>
  <div>
    <p class="font-weight-medium ml-2 mt-2" style="font-size: 14px">
      Configurações do automatizador de Tarefas
    </p>

    <v-tabs centered class="mt-n2">
      <v-tab>
        <v-icon left>mdi-cog</v-icon>
        Automatizador
      </v-tab>

      <v-tab-item class="ma-0">
        <v-card flat>
          <v-card-text class="pa-0">
            <automatizador-tarefas></automatizador-tarefas>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import automatizadorTarefas from "./AutomatizadorTarefas.vue";

export default {
  components: {
    automatizadorTarefas
  },
  name: "Automatizador",

  created() {
    this.Helpers.verificarToken();
  },
};
</script>
<style>
.altura-tabela .v-data-table__wrapper {
  height: calc(100vh - 300px) !important;
}
</style>
